import { cabeceraColor, dangerColor, defaultFont, grayColor, successColor } from "assets/jss/style.js";
import { whiteColor } from "assets/jss/style.js";

const customInputStyle = {
  disabled: {
    "&:before": {
      backgroundColor: "transparent !important",
      color: "#333 !important"
    }
  },
  underline: {
    "&:hover:not($disabled):before,&:before": {
      borderColor: grayColor[4] + " !important",
      borderWidth: "1px !important"
    },
    "&:after": {
      borderColor: cabeceraColor[0]+ " !important"
    }
  },
  underlineError: {
    "&:after": {
      borderColor: dangerColor[0]+ " !important"
    }
  },
  underlineSuccess: {
    "&:after": {
      borderColor: successColor[0]+ " !important"
    }
  },
  labelRoot: {
    ...defaultFont,
    color:  "#333 !important",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "2",
    letterSpacing: "unset",
    marginTop:"0px !important" 
  },
  labelRootError: {
    color: dangerColor[0]+ " !important"
  },
  labelRootSuccess: {
    color: successColor[0]+ " !important"
  },
  labelRootBlanco: {
    color: whiteColor+ " !important",
    textAlign: "left !important"
  },
  feedback: {
    position: "absolute",
    top: "18px",
    right: "0",
    zIndex: "2",
    display: "block",
    width: "24px",
    height: "24px",
    textAlign: "center",
    pointerEvents: "none"
  },
  marginTop: {
    marginTop: "16px"
  },
  formControl: {
    paddingBottom: "10px",
    margin: "0px 0 0 0",
    position: "relative",
    verticalAlign: "unset"
  }
};

export default customInputStyle;
